import React, { memo } from 'react';

export const WallDiagonal: React.FC = memo(() => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2715_258383)">
      <rect
        x="4.625"
        y="4.625"
        width="38.75"
        height="38.75"
        rx="3.375"
        stroke="#464C5C"
        strokeWidth="1.25"
      />
      <path d="M20.4609 -0.748047L48.7452 27.5362" stroke="#464C5C" strokeWidth="1.25" />
      <path d="M26.3516 -5.41211L54.6358 22.8722" stroke="#464C5C" strokeWidth="1.25" />
      <path d="M40.2188 7.7832L34.6074 13.3945" stroke="#464C5C" strokeWidth="1.25" />
      <path d="M41.6719 20.4648L36.3686 25.7681" stroke="#464C5C" strokeWidth="1.25" />
      <path d="M26.9375 5.73047L21.6342 11.0338" stroke="#464C5C" strokeWidth="1.25" />
      <path d="M29.2969 18.6973L23.9936 24.0006" stroke="#464C5C" strokeWidth="1.25" />
      <path d="M31.0703 31.0703L25.767 36.3736" stroke="#464C5C" strokeWidth="1.25" />
      <path d="M16.3359 16.3379L11.0326 21.6412" stroke="#464C5C" strokeWidth="1.25" />
      <path d="M18.6953 29.3027L13.392 34.606" stroke="#464C5C" strokeWidth="1.25" />
      <path d="M20.4609 41.6777L16.9254 45.2133" stroke="#464C5C" strokeWidth="1.25" />
      <path d="M5.72656 26.9434L2.19103 30.4789" stroke="#464C5C" strokeWidth="1.25" />
      <path d="M15.1562 4.55469L43.4405 32.839" stroke="#464C5C" strokeWidth="1.25" />
      <path d="M6 6L41.988 42.0013" stroke="#464C5C" strokeWidth="1.25" />
      <path d="M4.55469 15.1621L32.839 43.4464" stroke="#464C5C" strokeWidth="1.25" />
      <path d="M-0.75 20.4648L27.5343 48.7491" stroke="#464C5C" strokeWidth="1.25" />
      <path d="M-3.10938 27.9004L25.1749 56.1847" stroke="#464C5C" strokeWidth="1.25" />
    </g>
    <defs>
      <clipPath id="clip0_2715_258383">
        <rect width="40" height="40" fill="white" transform="translate(4 4)" />
      </clipPath>
    </defs>
  </svg>
));
